import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SILENT_HTTP_STATUSES } from '@shared-angular/interceptors/http-error.interceptor';
import { ProviderStatus, StatusProvider } from '@shared/ProviderStatus';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProviderStatusService {
  private readonly http = inject(HttpClient);

  public getStatus(provider: StatusProvider): Observable<ProviderStatus> {
    return this.http.get<ProviderStatus>(`/api/admin/${provider}-status`, {
      // The status component displays polling failures persistently, without repeated error toasts.
      context: new HttpContext().set(SILENT_HTTP_STATUSES, [0, 400, 401, 403, 404, 429, 500, 502, 503, 504])
    });
  }
}
